import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconRecycle } from '../../../../../../shared/icon/icon'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { useApiFormAssetVersion, useApiListAssetVersion } from '../../../../../../api-new/state/content'
import { ColumnDateTime, ColumnMenu, ColumnSize, ColumnText, ColumnYesNo } from '../../../../../../shared/table-builder/table-columns'
import { Menu, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { Purge } from '../../../../../../shared/page/page-purge'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const AssetVersionlistRecycle = () => {
  const { assetID } = useParamsInt()

  const { url } = useRouteMatch()

  const apiListAssetVersion = useApiListAssetVersion()

  // const roleOrgNode = useRoleOrgNode()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAssetVersion.get(`${assetID}/deleted-parent`)
  const handleDestroyed = () => apiListAssetVersion.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListAssetVersion.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That asset version was already removed.'), err)
    }
    await apiListAssetVersion.get(`${assetID}/deleted-parent`)
  }

  // const roleSysApp = useRoleSysApp()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconRecycle} text="Recycle">
        <CardFullHeightScrollY title="recycle">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAssetVersion} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnDateTime field="createdAt" />
            <ColumnText field="filename" />
            <ColumnText field="storageKey" />
            <ColumnSize field="contentLength" />
            <ColumnYesNo field="isCurrent" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="note" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show />
                  <MenuPurge to={`${url}/purge/${row.id}`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/purge/:purgeID`}>
        <Purge useApiForm={useApiFormAssetVersion} titleParam="filename" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
